var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardientRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1438,
    height: 1156,
    viewBox: "0 0 1438 1156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 1438,
    height: 1156,
    transform: "matrix(1 0 0 -1 0 1156)",
    fill: "url(#paint0_linear_363_624)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_363_624",
    x1: 939,
    y1: 870.951,
    x2: 703.767,
    y2: -255.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624981,
    stopColor: "#00E8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01FE88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardientRectangle);
export default __webpack_public_path__ + "static/media/gardient_rectangle.65a59e4ea56239bb46e32c43b2dd171c.svg";
export { ForwardRef as ReactComponent };